import {
    SET_BRANCH_DROP_DOWN_LIST
} from "./BranchType";

const reducer = (state = [], action: any) => {
    switch (action.type) {
        case SET_BRANCH_DROP_DOWN_LIST:
            return {
                ...state,
                branchDropDown: action.response,
            };
        default:
            return state;
    }
};

export default reducer;